import {isEmpty, vuepayAlert} from "../../utility";
import {getData, LOGIN} from "../../storage";
import assets from "../../assets";

const getCommentListAPI = (props, type, uuid, pageCount) => {
    let page = pageCount ? pageCount : 1;

    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.getCommentList(
                data.token,
                data.api_token,
                type, uuid, pageCount
            );
        } else {
            //only run this if the searchQuery is blank
            props.getCommentList(
                null,
                null,
                type, uuid, pageCount
            );
        }
    });
};

const createCommentAPI = (props, postData) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.createComment(
                data.token,
                data.api_token,
                postData
            );
        }
    });
};

const updateCommentAPI = (props, comment_id,postData) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.updateComment(
                data.token,
                data.api_token,
                comment_id,
                postData
            );
        }
    });
};

const deleteCommentAPI = (props, comment_id) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.deleteComment(
                data.token,
                data.api_token,
                comment_id
            );
        }
    });
};

const getType = (props) => {
    const isVideo = props.location.pathname.indexOf("video") > 0;
    const isGallery = props.location.pathname.indexOf("gallery") > 0;
    const isPicture = props.location.pathname.indexOf("picture") > 0;

    if (isVideo) {
        return "video";
    } else if (isGallery) {
        return "gallery";
    } else if (isPicture) {
        return "picture";
    }

    return "video"
}

const getOtherUserDropDownItem = (reportAction) => {
    return [{
        slug: 'report',
        title: "Report",
        icon: assets.messaging.dropdown.report,
        action: reportAction
    }]
}

const getUserDropDownItem = (editAction, deleteAction, reportAction) => {
    return [{
        slug: 'edit',
        title: "Edit",
        icon: assets.clipstore.more.editVideo,
        action: editAction
    }, {
        slug: 'delete',
        title: "Delete",
        icon: assets.clipstore.more.deleteVideo,
        action: deleteAction
    }, {
        slug: 'report',
        title: "Report",
        icon: assets.messaging.dropdown.report,
        action: reportAction
    }]
}

const apiUpdate = (nextProps,key,successCallback,resetCallback) => {

    if (nextProps[key] && nextProps[key].payload) {
        if (nextProps[key].payload.hasOwnProperty("success") &&
            nextProps[key].payload.success &&
            nextProps[key].payload.success.hasOwnProperty("data")) {
            successCallback();
            vuepayAlert("success", nextProps[key].payload.success.message)
        } else if ((nextProps[key].payload.hasOwnProperty("error") &&
            nextProps[key].payload.error &&
            nextProps[key].payload.error.hasOwnProperty("message"))) {
            vuepayAlert("error", nextProps[key].payload.error.message)
        }
        resetCallback();
    }
}
export default {
    getCommentListAPI,
    createCommentAPI,
    updateCommentAPI,
    deleteCommentAPI,
    getType,
    getOtherUserDropDownItem,
    getUserDropDownItem,
    apiUpdate
}